import React from "react"
import PropTypes from "prop-types"
import { uniqueId } from "lodash"

import {
  StyledInputWrapper,
  StyledInput,
  StyledCheckValidation,
  StyledCrossValidation,
} from "./partials"

import { StyledFieldWrapper } from "./partials/StyledField"
import IconV2 from "../icon-v2"

const Input = ({
  id,
  placeholder,
  name,
  label,
  type,
  required,
  hidden,
  disable,
  value,
  onChange,
  isValid,
  isDark,
  loading,
  half,
}) => {
  const htmlId = uniqueId(id)

  let inputElement = null;

  let pattern = null

  switch (type) {
    case "password":
    inputElement = (
          <input
            className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
            pattern="^(?!.*').*(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$"
            id={htmlId}
            name={name}
            type={"password"}
            placeholder={placeholder}
            required={required}
            disabled={loading ? "disabled" : disable}
            value={value}
            onChange={(e) => {
                if (id) {
                const { value, validity } = e.target
                onChange(id, { value: value, valid: validity.valid })
                } else onChange(e)
            }}
          />
        );
        break;
      case "email":
        inputElement = (
          <input
            className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
            pattern="^(?!.*').+[A-Za-z0-9._+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$"
            id={htmlId}
            name={name}
            type={type}
            placeholder={placeholder}
            required={required}
            disabled={loading ? "disabled" : disable}
            value={value}
            onChange={(e) => {
                if (id) {
                    const { value, validity } = e.target
                onChange(id, { value: value, valid: validity.valid })
                } else onChange(e)
            }}
        />
        );
        break;
      default:
        if (name === "linkedin") {
          inputElement = (
            <input
              className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
              id={htmlId}
              name={name}
              type={type}
              placeholder={placeholder}
              required={required}
              disabled={loading ? "disabled" : disable}
              value={value}
              onChange={(e) => {
                const inputValue = e.target.value;
                const isValid = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+(\/)?(\s|$)/.test(inputValue);
                if (id) {
                  onChange(id, { value: inputValue, valid: isValid });
                } else {
                  onChange(e);
                }
              }}
            />
          );
        } else if (name === "firstName" || name === "lastName") {
          inputElement = (
            <input
              className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
              pattern="^(?!\s*$)[a-zA-Zà-ÿÀ-Ÿ '’\-.,]+$"
              id={htmlId}
              name={name}
              type={type}
              maxLength={35}
              placeholder={placeholder}
              required={required}
              disabled={loading ? "disabled" : disable}
              value={value}
              onChange={(e) => {
                if (id) {
                    const { value, validity } = e.target
                onChange(id, { value: value, valid: validity.valid })
                } else onChange(e)
            }}
        />
          );
        } else {
          inputElement = (
            <input
              className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
              pattern="\S(.*)?"
              id={htmlId}
              name={name}
              maxLength={75}
              type={type}
              placeholder={placeholder}
              required={required}
              disabled={loading ? "disabled" : disable}
              value={value}
              onChange={(e) => {
                const { value, validity } = e.target;
                if (id) {
                  onChange(id, { value: value, valid: validity.valid });
                } else {
                  onChange(e);
                }
              }}
            />
          );
        }
        break;
    }

  return (
    <>
        <StyledFieldWrapper
        data-name="field-input"
            isDark={isDark}
            hidden={hidden}
            valid={isValid}
            loading={loading}
            half={name === "firstName" || name === "lastName" ? true : half}
            empty={value.length < 1}
        >
          <div>
            {isValid && (<IconV2 icon={"check-circle"} size={"14"} iconType={"fas"} />)}
            {isValid === false && (<IconV2 icon={"exclamation-circle"} size={"14"} iconType={"fas"} />)}
            {inputElement}
            {label && <label htmlFor={htmlId}>{label}</label>}
          </div>
          {isValid === false && (
            value.length > 0 ? (
              <span>
                {type === "password"
                  ? "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters. Please exclude apostrophe."
                  : type === "email"
                  ? "Invalid data entry: if included, please exclude apostrophe."
                  : "Invalid data entry: if included, please exclude non-latin letters."
                }
              </span>
            ) : (
              <span>This is required</span>
            )
          )}
        </StyledFieldWrapper>
    </>
  )
}

Input.defaultProps = {
  id: "",
  className: "",
  name: "",
  placeholder: "",
  label: "",
  type: "text",
  hidden: false,
  required: false,
  disable: false,
  value: "",
  onChange: () => {},
  isValid: undefined,
  loading: false,
}

Input.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  hide_label: PropTypes.bool,
  type: PropTypes.string,
  required: PropTypes.bool,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  loading: PropTypes.bool,
}

export default Input
